import React, { useEffect } from "react";
import {
  ActionIcon,
  Box,
  Button,
  Menu,
  ScrollArea,
  Table,
  Text,
  createStyles,
} from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import { IconEdit, IconEye, IconTrash } from "@tabler/icons-react";
import { BiDotsVerticalRounded } from "react-icons/bi";
import swal from "sweetalert";
import RecordNotFound from "../../RecordNotFound";
import TableLoader from "../../TableLoader";
import EditConsumer from "../Dashboard/EditConsumer";
import ViewConsumerDrawer from "../Dashboard/ViewConsumerDrawer";
import Newconsumer from "../Dashboard/Newconsumer";
import { getAllBillingConsumers, removeBillingConsumer } from "../../../services/billinginvoice";
import CustomInvoicePagination from "../../Pagination/CustomInovicePagination";
import StatusBtn from "../../StatusBtn";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      // backgroundColor: "var(--app-border)",
      color: "var(--app-text) !important",
    },
    "& th:first-of-type": {
      borderTopLeftRadius: "16px !important",
      borderBottomLeftRadius: "16px !important",
    },
    "& th:last-of-type": {
      borderTopRightRadius: "16px !important",
      borderBottomRightRadius: "16px !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
    borderRadius: "15px",
  },
  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
  tableHeader: {
    borderBottom: "none !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },
  bg1: {
    "& td": {
      background: "var(--app-surface)",
    },
  },
  bg2: {
    "& td": {
      background: "var(--app-surface-2)",
    },
  },
}));

// const PreviousCustomers = () => {
const PreviousCustomers = ({ createconsumer, setCreateConsumer }) => {
  const { classes, cx } = useStyles();
  const { patients } = useSelector((state) => state.patient);
  const [editcustomer, setEditcustomer] = useState(false);
  const [isEdit, setIsEdit] = useState("");
  const [viewcustomer, setViewcustomer] = useState(false);
  const [customer, setCustomer] = useState(false);
  const [isPreview, setIsPreview] = useState(false);

  const [scrolled, setScrolled] = useState(false);
  // const [createconsumer, setCreateConsumer] = useState();

  const { allbillinginvoicesConsumer,loading } = useSelector(
    (state) => state.billinginvoiceReducer
  );

  let currentId = 1;

  function generateSequentialId() {
    const id = String(currentId).padStart(6, "0");
    currentId++;
    return id;
  }

  const onEdit = (data) => {
    setCustomer(data);
    setEditcustomer(true);
    setIsEdit("isEdit");
  };

  const onView = (data) => {
    setCustomer(data);
    setViewcustomer(true);
  };

  const remove = async (id) => {
    let payload = {
      id,
    };

    // event.stopPropagation();
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removeBillingConsumer(payload);
  };

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
      getAllBillingConsumers({ page: currentPage });
    }, [currentPage]);

  return (
    <>
      {/* <Box className={classes.flexend}>
  <Button
             onClick={() => {
              setCreateConsumer(true);
            }}
            variant="filled"
            type="submit"
            c={"var(--app-on-primary)"}
            radius={"md"}
            size="md"
            sx={{ backgroundColor: "var(--app-primary)", color: "var(--app-on-primary)", "&:hover": { backgroundColor: "var(--app-primary)", filter: "brightness(0.95)" } }}
          >
            New Customer
          </Button>

          </Box> */}
      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        sx={{
          marginTop: "30px",
          minHeight: "300px",
          outline: "2px solid #1018280D ",
          borderRadius: 5,
        }}
      >
        <Table
          // withBorder
          highlightOnHover
          enableStickyHeader
          sx={{ fontFamily: "Inter", borderRadius: "15px" }}
          fontSize={"sm"}
          verticalSpacing={"md"}
        >
          <thead
            className={cx(classes.header, { [classes.scrolled]: scrolled })}
          >
            <tr>
              <th
                style={{ minWidth: "75px", fontWeight: "700" }}
                className={classes.tableHeader}
              >
                Status
              </th>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Customer ID
              </th>
              <th style={{ minWidth: "80px" }} className={classes.tableHeader}>
                CreatedDate
              </th>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Customer Name
              </th>

              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Customer Email
              </th>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Last Payment Date
              </th>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Total Receivables
              </th>

              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Action
              </th>
            </tr>
          </thead>

          <tbody className={cx(classes.tablebody)}>
            {loading ? (
              <tr>
                <td colSpan={1000}>
                  <TableLoader />
                </td>
              </tr>
            ) : allbillinginvoicesConsumer &&
              allbillinginvoicesConsumer?.billinginvoice?.length > 0 ? (
              allbillinginvoicesConsumer?.billinginvoice?.map((row, index) => (
                <tr key={index}>
                  <td>
                    <StatusBtn status={row.status} />
                  </td>
                  {/* <td>{generateSequentialId()}</td> */}
                  <td>{row?.consumerId}</td>
                  <td>
                    {row?.createdAt
                      ? new Date(row?.createdAt).toLocaleDateString("en-US")
                      : " date Not Available"}
                  </td>

                    <td>{row.name}</td>
                    <td>{row.email}</td>
                    <td>
                      {row?.lastPaymentDate
                        ? new Date(row?.lastPaymentDate).toLocaleDateString(
                            "en-US"
                          )
                        : " date Not Available"}
                    </td>
                    <td>${row.totalReceivables || 0}</td>
                    <td>
                      <Menu shadow="md" position="left" zIndex={"1000"}>
                        <Menu.Target>
                          <ActionIcon className={classes.marginTop}>
                            <BiDotsVerticalRounded
                              id="vertical-dots"
                              size={20}
                              color="var(--app-text)"
                            />
                          </ActionIcon>
                        </Menu.Target>
                        <Menu.Dropdown>
                          <Menu.Item
                            id="open-link"
                            icon={<IconEye size={14} />}
                            onClick={() => {
                              onView(row);
                              // onEdit(row);
                              // setIsPreview(true);
                            }}
                          >
                            View
                          </Menu.Item>
                          <Menu.Item
                            icon={<IconEdit size={14} />}
                            onClick={() => onEdit(row)}
                          >
                            Edit
                          </Menu.Item>
                          <Menu.Item
                            icon={<IconTrash size={14} />}
                            color="red"
                            onClick={() => remove(row.id)}
                          >
                            Delete
                          </Menu.Item>
                        </Menu.Dropdown>
                      </Menu>
                    </td>
                  </tr>
              ))
            ) : (
              <tr>
                <td colSpan={1000}>
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      height: "75vh",
                      gap: "8rem",
                    }}
                  >
                    <RecordNotFound />
                    <Text className="notFoundText">
                      You don&apos;t have any record, click on “Create Invoices”
                    </Text>
                  </Box>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </ScrollArea>
      <CustomInvoicePagination
        data={allbillinginvoicesConsumer?.count}
        itemsPerPage={10}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
      />

      {/* <EditConsumer
        editcustomer={editcustomer}
        setEditcustomer={setEditcustomer}
        customer={customer}
        setCustomer={setCustomer}
        // isPreview={isPreview}
        // setIsPreview={setIsPreview}
      /> */}

      <ViewConsumerDrawer
        viewcustomer={viewcustomer}
        setViewcustomer={setViewcustomer}
        customer={customer}
        setIsPreview={setIsPreview}
      />

      <Newconsumer
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        setIsPreview={setIsPreview}
        setEditcustomer={setEditcustomer}
        customer={customer}
        setCustomer={setCustomer}
        editcustomer={editcustomer}
        createconsumer={createconsumer}
        setCreateConsumer={setCreateConsumer}
      />
    </>
  );
};

export default PreviousCustomers;
